import type { Id, ISODate } from '@contracts/common';
import { useDelegationWrite } from './api';
import { dayMonth } from './format';
import './delegation.css';

/**
 * AI S9 L3 T6 (§7.2, mockup §1, §3): the delegator's answer to a deadline request, on the card and in the bell.
 * "Chấp nhận 14/10" names the asked day; an accept moves the card's deadline, so the hook reads the card again.
 */
export function DecideButtons({ itemId, round, version, requestedDeadline }: {
  itemId: Id; round: number; version: number; requestedDeadline: ISODate | null;
}) {
  const write = useDelegationWrite(itemId);
  const decide = (decision: 'accept' | 'decline') => write.mutate({ op: 'decide', body: { decision, round, version } });
  return (
    <>
      <button type="button" className="wp-btn wp-n-pri" disabled={write.isPending} onClick={() => decide('accept')}>
        {requestedDeadline === null ? 'Chấp nhận' : `Chấp nhận ${dayMonth(requestedDeadline)}`}
      </button>
      <button type="button" className="wp-btn" disabled={write.isPending} onClick={() => decide('decline')}>Từ chối</button>
    </>
  );
}
